<template>
  <ValidationObserver ref="observer">
  <b-container fluid="sm" v-if="loadMenu" class="menu-page-scroll">
    <!-- Layer 1 -->
    <b-card class="mb-4 shadow-sm" style="padding: 10px 24px">
      <b-card-title class="mb-4">Menu Configuration</b-card-title>
      <b-row class="mb-3 border-bottom pb-3">
        <b-col md="6">
          <b-form-group label="Parent Menu Id" label-align="left">
            <b-form-input :value="defaultParentMenuId" disabled />
          </b-form-group>
        </b-col>
        <b-col md="6">
          <ValidationProvider name="Parent Menu Name" rules="required" v-slot="{ errors }">
            <b-form-group label="Parent Menu Name" label-align="left" class="position-relative">
              <div class="d-flex align-items-center">
                <multiselect
                    v-model="parentMenuId"
                    :options="parentMenuIdOptions"
                    :multiple="false"
                    select-label="Select"
                    deselect-label="Unselect"
                    :limit="1"
                    label="name"
                    track-by="id"
                    :close-on-select="false"
                    :clear-on-select="false"
                    :preserve-search="true"
                    class="flex-grow-1"
                ></multiselect>

                <!-- Add icon button with tooltip -->
                <b-button
                    variant="link"
                    class="ml-2 p-0 text-primary"
                    v-b-tooltip.hover="'Add new Parent Menu Id'"
                    @click="showParentMenuModal = true"
                >
                  <b-icon-plus-circle font-scale="1.5"></b-icon-plus-circle>
                </b-button>
              </div>
              <span class="text-danger">{{ errors[0] }}</span>
            </b-form-group>
          </ValidationProvider>

          <!-- Modal for adding new parent menu -->
          <b-modal v-model="showParentMenuModal" title="Add New Parent Menu" @ok="addNewParentMenu">
            <b-form-group label="Parent Menu Name">
              <b-form-input v-model="newParentMenuName" placeholder="Enter parent menu name"></b-form-input>
            </b-form-group>
            <b-form-group label="Parent Menu Id">
              <b-form-input v-model="newParentMenuId" placeholder="Enter parent menu id"></b-form-input>
            </b-form-group>

            <template #modal-footer="{ ok, cancel }">
              <b-button variant="secondary" @click="cancel">Cancel</b-button>
              <b-button variant="primary" @click="ok">OK</b-button>
            </template>
          </b-modal>
        </b-col>
        <b-col md="6">
          <b-form-group label="Menu Id" label-align="left">
            <b-form-input :value="fetchDefaultvalues[0].menuId" disabled />
          </b-form-group>
        </b-col>
        <b-col md="6">
          <ValidationProvider name="Menu Id" rules="required" v-slot="{ errors }">
            <b-form-group label="Menu Id" label-align="left">
              <b-form-input v-model="menuId" :placeholder="menuIdPlaceholder" />
              <span class="text-danger">{{ errors[0] }}</span>
            </b-form-group>
          </ValidationProvider>
        </b-col>
        <b-col md="6">
          <b-form-group label="Menu Name" label-align="left">
            <b-form-input :value="defaultMenuName" disabled />
          </b-form-group>
        </b-col>
        <b-col md="6">
          <ValidationProvider name="Menu Name" rules="required" v-slot="{ errors }">
            <b-form-group label="Menu Name" label-align="left">
              <b-form-input v-model="menuName" :placeholder="menuNamePlaceholder" />
              <span class="text-danger">{{ errors[0] }}</span>
            </b-form-group>
          </ValidationProvider>
        </b-col>
      </b-row>
      <b-row class="mb-3 border-bottom pb-3">
        <b-col md="6">
          <b-form-group label="Screen Title" label-align="left">
            <b-form-input :value="defaultMenuName" disabled />
          </b-form-group>
        </b-col>
        <b-col md="6">
          <ValidationProvider name="Screen Title" rules="required" v-slot="{ errors }">
            <b-form-group label="Screen Title" label-align="left">
              <b-form-input v-model="screenName" placeholder="Enter the Screen Title" />
              <span class="text-danger">{{ errors[0] }}</span>
            </b-form-group>
          </ValidationProvider>
        </b-col>
        <b-col md="6">
          <b-form-group label="Filter SQL Id" label-align="left">
            <b-form-input :value="fetchDefaultvalues[0].screenletListbox1_sqlId" disabled />
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group label="Filter SQL Id" label-align="left">
            <b-form-input v-model="filterSqlId" placeholder="Enter the Filter SQL"/>
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group label="Filter Syspk" label-align="left">
            <b-form-input :value="JSON.stringify(defaultFilterSyspk)" disabled />
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group label="Filter Syspk" label-align="left">
            <b-form-input v-model="filterSyspk" placeholder="Enter the Filter Syspk"/>
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group label="Data SQL Id" label-align="left">
            <b-form-input :value="fetchDefaultvalues[0].datasqlId" disabled />
          </b-form-group>
        </b-col>
        <b-col md="6">
          <ValidationProvider name="Data SQL Id" rules="required" v-slot="{ errors }">
            <b-form-group label="Data SQL Id" label-align="left">
              <b-form-input v-model="dataSqlId" placeholder="Enter the Data SQL" />
              <span class="text-danger">{{ errors[0] }}</span>
            </b-form-group>
          </ValidationProvider>
        </b-col>
        <b-col md="6">
          <b-form-group label="Viz Type" label-align="left">
            <b-form-input :value="fetchDefaultvalues[0].viztypeName" disabled />
          </b-form-group>
        </b-col>
        <b-col md="6">
          <ValidationProvider name="Viz Type" rules="required" v-slot="{ errors }">
            <b-form-group label="Viz Type" label-align="left">
              <multiselect
                  v-model="vizTypeName"
                  :options="vizTypeOptions"
                  :multiple="false"
                  select-label="Select"
                  deselect-label="Unselect"
                  :limit="1"
                  :close-on-select="false"
                  :clear-on-select="false"
                  :preserve-search="true"
              >
              </multiselect>
              <span class="text-danger">{{ errors[0] }}</span>
            </b-form-group>
          </ValidationProvider>
        </b-col>
<!--        <b-col sm="4">-->
<!--          <b-form-group label="Viz Size ID">-->
<!--            <b-form-input :value="fetchDefaultvalues[0].vizletSizeId" disabled />-->
<!--          </b-form-group>-->
<!--        </b-col>-->
<!--        <b-col sm="4">-->
<!--          <b-form-group label="Viz Size ID">-->
<!--            <b-form-select v-model="vizSizeId" :options="vizSizeOptions" required />-->
<!--          </b-form-group>-->
<!--        </b-col>-->
      </b-row>
      <b-row>
        <!-- X-Axis Name -->
        <b-col md="6">
          <b-form-group label="X-Axis Name" label-align="left">
            <b-form-input :value="fetchDefaultvalues[0].x1_axisDisplayName" disabled />
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group label="X-Axis Name" label-align="left">
            <b-form-input v-model="x_axisName" placeholder="Enter the XAxis Name"/>
          </b-form-group>
        </b-col>

        <!-- Y-Axis Name -->
        <b-col md="6">
          <b-form-group label="Y-Axis Name" label-align="left">
            <b-form-input :value="fetchDefaultvalues[0].y1_axisDisplayName" disabled />
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group label="Y-Axis Name" label-align="left">
            <b-form-input v-model="y_axisName" placeholder="Enter the YAxis Name"/>
          </b-form-group>
        </b-col>

        <!-- Viz Title Name -->
        <b-col md="6">
          <b-form-group label="Viz Title" label-align="left">
            <b-form-input :value="fetchDefaultvalues[0].vizletTitleDpName" disabled />
          </b-form-group>
        </b-col>
        <b-col md="6">
          <ValidationProvider name="Viz Title" rules="required" v-slot="{ errors }">
            <b-form-group label="Viz Title" label-align="left">
              <b-form-input v-model="vizTitleName" required placeholder="Enter the Viz Title"/>
              <span class="text-danger">{{ errors[0] }}</span>
            </b-form-group>
          </ValidationProvider>
        </b-col>

        <!-- X-Axis Tooltip -->
        <b-col md="6">
          <b-form-group label="X-Axis Tooltip" label-align="left">
            <b-form-input :value="fetchDefaultvalues[0].x1_metricTooltip" disabled />
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group label="X-Axis Tooltip" label-align="left">
            <b-form-input v-model="x_axisTooltip" placeholder="Enter the XAxis Tooltip"/>
          </b-form-group>
        </b-col>

        <!-- Y-Axis Tooltip -->
        <b-col md="6">
          <b-form-group label="Y-Axis Tooltip" label-align="left">
            <b-form-input :value="fetchDefaultvalues[0].y1_metricTooltip" disabled />
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group label="Y-Axis Tooltip" label-align="left">
            <b-form-input v-model="y_axisTooltip" placeholder="Enter the YAxis Tooltip"/>
          </b-form-group>
        </b-col>

        <!-- X-Axis Data Name -->
        <b-col md="6">
          <b-form-group label="X-Axis Data Name" label-align="left">
            <b-form-input :value="fetchDefaultvalues[0].x1_dataFieldName" disabled />
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group label="X-Axis Data Name" label-align="left">
            <b-form-input v-model="x_axisDataName" placeholder="Enter the XAxis Data Name"/>
          </b-form-group>
        </b-col>

        <!-- Y-Axis Data Name -->
        <b-col md="6">
          <b-form-group label="Y-Axis Data Name" label-align="left">
            <b-form-input :value="fetchDefaultvalues[0].y1_dataFieldName" disabled />
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group label="Y-Axis Data Name" label-align="left">
            <b-form-input v-model="y_axisDataName" placeholder="Enter the YAxis Data Name"/>
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group label="Table Headers" label-align="left">
            <b-form-textarea :value="JSON.stringify(fetchDefaultvalues[0].reportHeaderColumnDp)"  disabled />
          </b-form-group>
        </b-col>
      </b-row>

      <!-- Table Headers as Key-Value JSON -->
      <b-card-title>Table Headers</b-card-title>
      <div
          v-for="(field, index) in tableHeaders"
          :key="field.id"
          class="d-flex align-items-center mb-3"
      >
        <b-form-group label="Header Name" :label-for="'header-name-' + field.id" class="mr-3 flex-grow-1">
          <b-form-input
              :id="'header-name-' + field.id"
              v-model="field.header"
              placeholder="Enter Header Name"
          ></b-form-input>
        </b-form-group>

        <b-form-group label="Value" :label-for="'header-value-' + field.id" class="mr-3 flex-grow-1">
          <b-form-input
              :id="'header-value-' + field.id"
              v-model="field.value"
              placeholder="Enter Value"
          ></b-form-input>
        </b-form-group>

        <b-button variant="danger" @click="removeField(index)" class="mt-4">
         Remove
        </b-button>
      </div>

      <b-button variant="success" @click="addField">
         Add Field
      </b-button>

      <div class="d-flex justify-content-end mt-4">
        <b-button variant="danger" @click="resetForm" class="mr-2">
          Reset
        </b-button>
        <b-button variant="primary" @click="submitForm">
          Submit
        </b-button>
      </div>
    </b-card>
  </b-container>
  </ValidationObserver>
</template>


<script>
import axios from "axios";
import { ValidationProvider, ValidationObserver, extend } from "vee-validate";
import { required } from "vee-validate/dist/rules";
import Multiselect from "vue-multiselect/src/Multiselect.vue";
import { BIconPlusCircle } from 'bootstrap-vue';

// Add required rule
extend("required", {
  ...required,
  message: "{_field_} is required"
});

export default {
  name: "menuConfig",
  components: {
    Multiselect,
    ValidationProvider,
    ValidationObserver,
    BIconPlusCircle
  },
  watch:{},
  created() {
    const uniqueParentMenuIdsMap = new Map();
    this.$store.state.menuMasterData.forEach(item => {
      if (item.menuId !== null && item.menuId !== undefined) { // Optional: exclude null/undefined IDs if they exist in source
        uniqueParentMenuIdsMap.set(item.menuId, {
          id: item.menuId,
          name: item.menuName
        });
      }
    });
    let allParentMenuIds = Array.from(uniqueParentMenuIdsMap.values());
    this.parentMenuIdOptions = allParentMenuIds
    const parentId = this.$store.state.menuMasterFlat.find(item=> item.menuId === 'I11YTD').parentMenuId;
    this.defaultParentMenuId = this.$store.state.menuMasterData.find(item=>item.menuId===parentId).menuName;
    console.log("default",this.$store.state.menuMasterData);
    this.defaultMenuName = this.$store.state.menuMasterFlat.find(item=> item.menuId === 'I11YTD').menuName;
    this.vizTypeOptions = this.$store.state.vizType.map(item=>item.viztypeName).sort();
    this.defaultFilterSyspk = this.$store.state.fwConfigMenuScreenRender.find(item=>item.menuId==='I11YTD').screenletListboxSyspkArray
    console.log(this.defaultFilterSyspk)
  },
  data: () => ({
      // Layer 1
      loadMenu:true,
      defaultParentMenuId:null,
      parentMenuId: null,
      parentMenuIdOptions: [],
      radioValue: '1',
      dimension: '2D',
      dimensionOptions: [
        { text: '2D', value: '2D' },
        { text: '3D', value: '3D' }
      ],

      // Layer 2
      menuId: '',
      menuIdPlaceholder: 'Enter Menu Id',
      defaultMenuName:'',
      menuName: '',
      menuNamePlaceholder: 'Enter Menu Name',

      // Layer 3
      screenName: '',
      screenNamePlaceholder: 'Enter Screen Name',
      filterSqlId: '',
      filterSqlIdPlaceholder: 'Enter Filter SQL Id',
      defaultFilterSyspk:'',
      filterSyspk:'',
      filterSyspkPlaceholder: 'Enter Filter Syspk',

      // Layer 4
      dataSqlId: '',
      dataSqlIdPlaceholder: 'Enter Data SQL Id',
      vizTypeName: '',
      vizTypeOptions: [ /* viz type options */ ],
      vizSizeId: 'VS72',
      vizSizeOptions: [ /* viz size options */ ],

      // Layer 5
      x_axisName: '',
      xAxisNamePlaceholder: 'Enter X-Axis Name',
      y_axisName: '',
      yAxisNamePlaceholder: 'Enter Y-Axis Name',
      vizTitleNamePlaceholder: 'Enter Viz Title Name',
      vizTitleName:'',
      x_axisTooltip: '',
      xAxisTooltipPlaceholder: 'Enter X-Axis Tooltip',
      y_axisTooltip: '',
      yAxisTooltipPlaceholder: 'Enter Y-Axis Tooltip',
      x_axisDataName: '',
      xAxisDataNamePlaceholder: 'Enter X-Axis Data Name',
      y_axisDataName: '',
      yAxisDataNamePlaceholder: 'Enter Y-Axis Data Name',
      tableHeaders: [],
      nextFieldId: 0,
      showParentMenuModal: false,
      newParentMenuName: '',
      newParentMenuId:''
  }),
  computed:{
    fetchDefaultvalues(){
      const vizData = this.$store.state.fwConfigScreenElement.filter(item=> item.menuId === 'I11YTD')
      console.log(vizData)
      return vizData
    }
  },
  methods: {
    async addNewParentMenu() {
      try {
        // Call your API to add new parent menu

      } catch (error) {
        console.error('Error adding parent menu:', error);
        // Handle error (show toast/message)
      }
    },
    submitForm() {
      this.$refs.observer.validate().then(valid => {
        if (valid) {
          this.loadMenu = false;
          this.postConfigMenu();
        } else {
          this.$bvToast.toast("Please fill all required fields", {
            title: 'Validation Error',
            variant: 'danger',
            solid: true
          });
        }
      });
    },
    postConfigMenu(){
      console.log("this.",this.tableHeaders);
      const transformedHeaders = this.tableHeaders.reduce((acc, current) => {
        acc[current.header] = current.value;
        return acc;
      }, {});


      const jsonString = JSON.stringify(transformedHeaders);
      const formData = {
        parentMenuId: this.parentMenuId.id,
        menuId: this.menuId,
        menuName: this.menuName,
        screenName: this.screenName,
        filterSqlId: this.filterSqlId,
        filterSyspk: this.filterSyspk,
        dataSqlId: this.dataSqlId,
        vizSizeId : this.vizSizeId,
        vizTypeName: this.vizTypeName,
        x_axisName: this.x_axisName,
        y_axisName: this.y_axisName,
        vizTitleName: this.vizTitleName,
        x_axisTooltip: this.x_axisTooltip,
        y_axisTooltip: this.y_axisTooltip,
        x_axisDataName: this.x_axisDataName,
        y_axisDataName: this.y_axisDataName,
        tableHeaders: jsonString
      };
      console.log("form data",formData);
      axios.post('/api/sp-config-menu',formData).then(resp=>{
        console.log(resp);
        if(resp.status===200){
          this.$bvToast.toast("Menu has been successfully configured and saved.", {
            title: 'Success',
            variant: 'success',
            solid: true
          });
          this.loadMenu = true
          this.resetForm();
        }
      }).catch(e=>{
        console.log("error",e);
        this.$bvToast.toast("Please try again. If the problem persists, contact support.", {
          title: 'Failed to Save Menu',
          variant: 'error',
          solid: true
        });
      })
    },
    resetForm() {
      // Reset all form fields to their initial values
      this.parentMenuId = '';
      this.menuId = '';
      this.menuName = '';
      this.screenName = '';
      this.filterSqlId = '';
      this.filterSyspk = '';
      this.dataSqlId = '';
      this.vizTypeName = '';
      this.x_axisName = '';
      this.y_axisName = '';
      this.vizTitleName = '';
      this.x_axisTooltip = '';
      this.y_axisTooltip = '';
      this.x_axisDataName = '';
      this.y_axisDataName = '';
      this.tableHeaders = []; // Reset to default if you have one
    },
    addField() {
      this.tableHeaders.push({
        id: this.nextFieldId++, // Assign a unique ID for :key
        header: '',
        value: '',
      });
    },
    removeField(index) {
      this.tableHeaders.splice(index, 1);
    },
  }
};
</script>

<style scoped>
/* Add custom styling if needed */
.menu-page-scroll {
  max-height: calc(100vh - 80px);
  overflow-y: auto;
  padding-right: 10px;
}
</style>
